import generateState from './deliveryStatus/state'
import generateMutations from './deliveryStatus/mutations'
import generateActions from './deliveryStatus/actions'
import generateGetters from './deliveryStatus/getters'

const registeredDeliveries = []

function registerDelivery(name) {
    if (registeredDeliveries.includes(name)) return
    this.registerModule(`${name}`, {
        namespaced: true,
        state: generateState(),
        mutations: generateMutations(),
        actions: generateActions(),
        getters: generateGetters(),
    })
    registeredDeliveries.push(name)
}

function unregisterDelivery(name) {
    const idx = registeredDeliveries.indexOf(name)
    if (idx !== -1) {
        this.unregisterModule(name)
        registeredDeliveries.splice(idx, 1)
    }
}

export { registerDelivery, unregisterDelivery }
